class AlgoliaLoadMore extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      loadMore: this.getAttribute('load-more')
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {string} The CSS style block as a string.
   */
  getStyle() {
    const style = document.createElement('style');
    const css = `
      <style>
        .load-more {
          display: flex;
          justify-content: center;
          margin-top: 32px;
        }

        .load-more__btn {
          display: block;
          margin-inline: auto;
        }

        @media screen and (min-width: 990px) {
          .load-more {
            margin-top: 60px;
          }
        }
      </style>
    `;
    style.appendChild(document.createTextNode(css));
    return style;
  }

  /**
   * Renders the button content.
   * @returns {string} The rendered button.
   */
  render() {
    const style = this.getStyle();
    const div = document.createElement('div');
    div.classList.add('load-more');
    const button = document.createElement('button');
    button.classList.add('load-more__btn', 'text-center', 'button', 'button--primary');
    const span = document.createElement('span');
    span.classList.add('load-more__copy');
    span.textContent = this.settings.loadMore;
    button.appendChild(span);
    div.appendChild(button);

    return [style, div];
  }
}

customElements.define("algolia-load-more", AlgoliaLoadMore);